import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { getCurrencyConfig } from '@app/helpers/currency-format.helper';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxCurrencyDirective } from 'ngx-currency';

@Component({
  selector: 'app-validated-currency-input',
  templateUrl: './validated-currency-input.component.html',
  styleUrl: './validated-currency-input.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    NgxCurrencyDirective,
  ],
})
export class ValidatedCurrencyInputComponent {
  label = input<string>();
  feedback = input<string>();
  currencyCode = input.required<string>();
  inputFormControlName = input.required<string>();
  inputFormControl = input.required<FormControl>();
  validationTrainslations = input<{ [key: string]: string }>();
  leaveSpaceForValidation = input<boolean>(false);
  omitKeydownEnter = input<boolean>(false);

  currencyMask = computed(() => getCurrencyConfig(this.currencyCode()));

  hasRequiredValidator(): string | boolean {
    return this.inputFormControl().hasValidator(Validators.required);
  }

  errorKeys(): string[] {
    const control = this.inputFormControl();
    return control.errors ? Object.keys(control.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    return this.validationTrainslations()?.[errorKey] ?? errorKey;
  }

  onEnterKey(event: Event): void {
    event.preventDefault();
  }
}
